"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var ScrollablePane_base_1 = require("./ScrollablePane.base");
var ScrollablePane_styles_1 = require("./ScrollablePane.styles");
exports.ScrollablePane = Utilities_1.styled(ScrollablePane_base_1.ScrollablePaneBase, ScrollablePane_styles_1.getStyles, undefined, { scope: 'ScrollablePane' });
//# sourceMappingURL=ScrollablePane.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/ScrollablePane/ScrollablePane.js
// module id = 1137
// module chunks = 0